import { render, staticRenderFns } from "./BattleInfo.vue?vue&type=template&id=0e497186&scoped=true&"
import script from "./BattleInfo.vue?vue&type=script&lang=js&"
export * from "./BattleInfo.vue?vue&type=script&lang=js&"
import style0 from "./BattleInfo.vue?vue&type=style&index=0&id=0e497186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e497186",
  null
  
)

export default component.exports